/** Row from GET /stores/:storeId/delivery-shift-restrictions */
export interface DeliveryShiftRestrictionRow {
  deliveryShiftId: number;
  restrictedDistricts: number[];
}

export interface GetDeliveryShiftRestrictionsApiResponse {
  data: DeliveryShiftRestrictionRow[];
}

export interface PutDeliveryShiftRestrictionsPayload {
  restrictedDistrictIds: number[];
  excludedDistrictIdsFromRestriction: number[];
}

export function buildRestrictionPutPayload(
  initialIds: readonly number[],
  selectedIds: readonly number[],
): PutDeliveryShiftRestrictionsPayload {
  const initial = new Set(initialIds);
  const selected = new Set(selectedIds);
  const restrictedDistrictIds = [...selected].filter((id) => !initial.has(id));
  const excludedDistrictIdsFromRestriction = [...initial].filter(
    (id) => !selected.has(id),
  );
  return { restrictedDistrictIds, excludedDistrictIdsFromRestriction };
}

/** Raw API body for PUT response (backend may typo restrictedDistricts). */
export interface PutDeliveryShiftRestrictionsResponseData {
  deliveryShiftId: number;
  restrictedDistricts?: number[];
  /** Observed typo in some API responses */
  restrcitedDistricts?: number[];
}

export interface PutDeliveryShiftRestrictionsApiResponse {
  data: PutDeliveryShiftRestrictionsResponseData;
}

export function normalizePutRestrictionsDistricts(
  body: PutDeliveryShiftRestrictionsResponseData,
): number[] {
  return body.restrictedDistricts ?? body.restrcitedDistricts ?? [];
}
